import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({});

  const [formData, setFormData] = useState({
    deposit_enabled: "off", // default
      min_deposit: "",
  max_deposit: "",
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}user/settings`
      );

      setSettings(response.data);

      // ✅ normalize data (important)
      setFormData({
        ...response.data,
        deposit_enabled: response.data.deposit_enabled || "off",
          min_deposit: response.data.min_deposit || "",
  max_deposit: response.data.max_deposit || "",
      });
    } catch (error) {
      Swal.fire("Error!", "Failed to load settings.", "error");
    } finally {
      setLoading(false);
    }
  };

  // text input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // file change
  const handleFileChange = (e) => {
    setFormData({ ...formData, logo: e.target.files[0] });
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

// if (Number(formData.min_deposit) > Number(formData.max_deposit)) {
//   Swal.fire("Error!", "Min deposit cannot be greater than max deposit", "error");
//   return;
// }
 setLoading(true);
    try {
const formDataToSend = new FormData();

formDataToSend.append("deposit_enabled", formData.deposit_enabled);
formDataToSend.append("min_deposit", Number(formData.min_deposit));
formDataToSend.append("max_deposit", Number(formData.max_deposit));
formDataToSend.append("name", formData.name || "");
formDataToSend.append("players_count", Number(formData.players_count || 0));
formDataToSend.append("games_available", Number(formData.games_available || 0));
formDataToSend.append("bonus", Number(formData.bonus || 0));
formDataToSend.append("whatsapp_no", formData.whatsapp_no || "");
formDataToSend.append("whatsapp_support", formData.whatsapp_support || "");

if (formData.logo) {
  formDataToSend.append("logo", formData.logo);
}

      await axios.post(
      `${process.env.REACT_APP_API_URL}user/settings`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      Swal.fire("Success!", "Settings updated successfully!", "success");
      loadSettings();
    } catch (error) {
      Swal.fire("Error!", "Failed to update settings.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container changetext">
      <h3 className="text-center mt-2">Settings</h3>

      {loading ? (
        <div className="text-center my-3">
          <div className="spinner-border" role="status"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="border p-4 rounded shadow-sm bg-white"
        >
          {/* LOGO */}
          <div className="row mb-4">
            <div className="col-md-6 text-center position-relative">
              <label className="form-label fw-bold">Logo</label>
              <input
                type="file"
                className="form-control mb-2"
                onChange={handleFileChange}
              />

              {settings.logo && (
                <div className="logo_change">
                  <img
                    src={`https://api.Cash365days.in/uploads/${settings.logo}`}
                    alt="Logo"
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "5px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/* PHONE */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">WhatsApp No.</label>
              <PhoneInput
                country={"in"}
                value={formData.whatsapp_no || ""}
                onChange={(value) =>
                  setFormData({ ...formData, whatsapp_no: value })
                }
                inputProps={{
                  name: "whatsapp_no",
                  required: true,
                  className: "form-control w-100",
                }}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold">
                WhatsApp Support No.
              </label>
              <PhoneInput
                country={"in"}
                value={formData.whatsapp_support || ""}
                onChange={(value) =>
                  setFormData({ ...formData, whatsapp_support: value })
                }
                inputProps={{
                  name: "whatsapp_support",
                  required: true,
                  className: "form-control w-100",
                }}
              />
            </div>
          </div>

          {/* TEXT FIELDS */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                placeholder="Enter Name"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold">Players Count</label>
              <input
                type="number"
                className="form-control"
                name="players_count"
                value={formData.players_count || 0}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">Games Available</label>
              <input
                type="number"
                className="form-control"
                name="games_available"
                value={formData.games_available || 0}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold">Bonus</label>
              <input
                type="number"
                className="form-control"
                name="bonus"
                value={formData.bonus || 0}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ✅ FIXED TOGGLE */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">deposit  Status</label>

              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={formData.deposit_enabled === "on"} // ✅ FIX
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      deposit_enabled: e.target.checked ? "on" : "off", // ✅ FIX
                    })
                  }
                />

                <label className="form-check-label">
                  {formData.deposit_enabled === "on"
                    ? "🟢 Online"
                    : "🔴 Offline"}
                </label>
              </div>
            </div>
          </div>
{/* MIN / MAX DEPOSIT */}
<div className="row mb-3">
  <div className="col-md-6">
    <label className="form-label fw-bold">Min Deposit</label>
    <input
      type="number"
      className="form-control"
      name="min_deposit"
      value={formData.min_deposit || ""}
      onChange={handleChange}
      placeholder="Enter Min Deposit"
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-bold">Max Deposit</label>
    <input
      type="number"
      className="form-control"
      name="max_deposit"
      value={formData.max_deposit || ""}
      onChange={handleChange}
      placeholder="Enter Max Deposit"
    />
  </div>
</div>
          {/* SUBMIT */}
          <div className="text-end">
            <button className="btn btn-primary px-4 mt-3">
              Update Settings
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Settings;